<template>
  <div class="page">
    <Header class="header" :show-back="showBack" @back="onBack" />
    <div class="main">
      <div v-if="langSelector" class="lang">
        <Selector v-model="$i18n.locale" :items="{ ja: 'JP', en: 'EN' }" @select="onChangeLang" />
      </div>
      <slot />
    </div>
    <Footer class="footer" />
    <LoadingIndicator v-if="loading" full />
  </div>
</template>

<script>
import Header from '@/components/organisms/Header'
import Footer from '@/components/organisms/Footer'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Selector from '@/components/atoms/Selector'

/**
 * フォーム画面テンプレート
 */
export default {
  name: 'FormPage',
  components: {
    Header,
    Footer,
    LoadingIndicator,
    Selector,
  },
  props: {
    /** 言語切り替え表示 */
    langSelector: { type: Boolean, default: false },
    /** ローディング中 */
    loading: { type: Boolean, default: false },
    /** 戻るボタン */
    showBack: { type: Boolean, default: false },
  },
  methods: {
    onChangeLang(lang) {
      /**
       * 言語の変更
       * @event
       * @type {string}
       */
      this.$emit('changeLang', lang)
    },
    onBack() {
      /**
       * 戻るボタンのクリック
       * @event
       */
      this.$emit('back')
    },
  },
}
</script>

<style lang="postcss" scoped>
.page {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.main {
  background: #fff;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin: auto;
  width: 100%;

  @media screen and (min-width: 768px) {
    background: none;
    margin: 16px auto 56px;
    max-width: 940px;
  }
}

.lang {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  margin: auto;
  padding: 8px 16px;
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: 740px;
    padding: 0 0 24px;
  }
}
</style>
